import uniqBy from 'lodash.uniqby';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var runtime_1 = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined$1; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  define(Gp, "constructor", GeneratorFunctionPrototype);
  define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined$1) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined$1;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined$1;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined$1;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined$1, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined$1;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined$1;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined$1;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined$1;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined$1;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   module.exports 
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}
});

var UserContext = /*#__PURE__*/function () {
  /** PRIVATE constructor, use `fromXXXX` methods instead */
  function UserContext() {
    this.id = UserContext.UNKNOWN_USER;
    this.language = undefined;
  }
  /** @deprecated Use `.language` instead */


  var _proto = UserContext.prototype;

  /** Reset the UserContext to default (invalid) values */
  _proto.reset = function reset() {
    this.id = UserContext.UNKNOWN_USER;
    this.language = undefined;
  }
  /** Get default UserContext */
  ;

  UserContext.getDefault = function getDefault() {
    return new UserContext();
  }
  /** Get anon version of UserContext */
  ;

  UserContext.getAnon = function getAnon() {
    var uc = new UserContext();
    uc.id = UserContext.ANON_USER;
    return uc;
  }
  /** Merge context with current one */
  ;

  _proto.apply = function apply(context) {
    if (context instanceof UserContext) {
      this.id = context.id;

      if (context != null && context.language) {
        this.language = context.language;
      }
    }

    return this;
  }
  /** Clone context */
  ;

  UserContext.fromContext = function fromContext(context) {
    return UserContext.getDefault().apply(context);
  }
  /** Get UserContext from UserContextTransport  */
  ;

  UserContext.fromTransport = function fromTransport(transport) {
    var newContext = UserContext.getDefault();

    if (typeof transport === 'object' && transport != null && transport.id) {
      var transportId = transport.id;

      if (typeof transportId === 'number') {
        newContext.id = transportId;
      } else if (typeof transportId === 'string') {
        newContext.id = parseInt(transportId, 10);
      }

      newContext.language = transport == null ? void 0 : transport.lang;
    }

    return newContext;
  }
  /** Get UserContext from window (via UserContextTransport)  */
  ;

  UserContext.fromWindow = function fromWindow() {
    var win = window;

    if (win != null && win._ulc && typeof win._ulc === 'object') {
      return UserContext.fromTransport(win._ulc);
    }

    return UserContext.getDefault();
  }
  /** Converts to UserContextTransport */
  ;

  _proto.toTransport = function toTransport() {
    return {
      id: this.id,
      lang: this.language
    };
  }
  /** Converts to stringified UserContextTransport */
  ;

  _proto.toString = function toString() {
    return JSON.stringify(this.toTransport());
  }
  /** Updates window with stringified UserContextTransport */
  ;

  _proto.updateWindow = function updateWindow() {
    var win = window;
    win._ulc = this.toTransport();
  }
  /** Updates script that updates window with stringified UserContextTransport */
  ;

  _proto.toScript = function toScript() {
    return "window._ulc = " + this.toString() + ";";
  };

  _createClass(UserContext, [{
    key: "lang",
    get: function get() {
      return this == null ? void 0 : this.language;
    }
    /** is user known? (ie. valid) derived from id */

  }, {
    key: "isUnknown",
    get: function get() {
      return this.id === UserContext.UNKNOWN_USER;
    }
    /** is user anon? derived from id */

  }, {
    key: "isAnon",
    get: function get() {
      return this.isUnknown || this.id === UserContext.ANON_USER;
    }
    /** @deprecated Use `.isAnon` instead */

  }, {
    key: "anon",
    get: function get() {
      return this.isAnon;
    }
  }]);

  return UserContext;
}();
UserContext.UNKNOWN_USER = -1;
UserContext.ANON_USER = 0;

var Product = {
  UNKNOWN: '',
  MEDIAWIKI: 'mw',
  DISCUSSIONS: 'dis',
  TRIVIA: 'trivia',
  F2: 'f2',
  FANHUB: 'fanhub',
  VIDEO: 'video',
  AUTH: 'auth'
};
var PageContext = /*#__PURE__*/function () {
  /** PRIVATE constructor, use `fromXXXX` methods instead */
  function PageContext() {
    /** Timestamp */
    this.$time = 0;
    this.product = Product.UNKNOWN;
    this.$time = Date.now();
  }

  var _proto = PageContext.prototype;

  /** Reset the PageContext to default (invalid) values */
  _proto.reset = function reset() {
    this.product = Product.UNKNOWN;
    this.productId = undefined;
    this.productVariant = undefined;
    this.productCategory = undefined;
    this.page = undefined;
    this.pageId = undefined;
    this.pageLanguage = undefined;
    this.adTags = undefined;
    this.pageName = undefined;
    this.pageLink = undefined;
    this.pageImage = undefined;
    this.communityName = undefined;
    this.communityImage = undefined;
    this.$time = Date.now();
  }
  /** Get default PageContext */
  ;

  PageContext.getDefault = function getDefault() {
    return new PageContext();
  }
  /** Zero the time portion of PageContext */
  ;

  _proto.zeroTime = function zeroTime() {
    this.$time = 0;
    return this;
  }
  /** Merge context with current one */
  ;

  _proto.apply = function apply(context) {
    if (context instanceof PageContext) {
      if (!context.isUnknown) {
        this.product = context.product;
      }

      if (context != null && context.productId) {
        this.productId = context.productId;
      }

      if (context != null && context.productVariant) {
        this.productVariant = context.productVariant;
      }

      if (context != null && context.productCategory) {
        this.productCategory = context.productCategory;
      }

      if (context != null && context.page) {
        this.page = context.page;
      }

      if (context != null && context.pageId) {
        this.pageId = context.pageId;
      }

      if (context != null && context.pageLanguage) {
        this.pageLanguage = context.pageLanguage;
      }

      if (context != null && context.adTags) {
        this.adTags = context.adTags;
      }

      if (context != null && context.pageName) {
        this.pageName = context.pageName;
      }

      if (context != null && context.pageLink) {
        this.pageLink = context.pageLink;
      }

      if (context != null && context.pageImage) {
        this.pageImage = context.pageImage;
      }

      if (context != null && context.communityName) {
        this.communityName = context.communityName;
      }

      if (context != null && context.communityImage) {
        this.communityImage = context.communityImage;
      }

      if (context != null && context.$time && typeof context.$time === 'number' && context.$time > 0) {
        this.$time = context.$time;
      }
    }

    return this;
  }
  /** Clone PageContext */
  ;

  PageContext.fromContext = function fromContext(context) {
    return PageContext.getDefault().apply(context);
  }
  /** Get PageContext from PageContextTransport  */
  ;

  PageContext.fromTransport = function fromTransport(transport) {
    var newContext = PageContext.getDefault(); // validate data

    if (transport.p) {
      newContext.product = transport.p;
      newContext.productId = transport == null ? void 0 : transport.pId;
      newContext.productVariant = transport == null ? void 0 : transport.pVar;
      newContext.productCategory = transport == null ? void 0 : transport.pCat;
      newContext.page = transport == null ? void 0 : transport.pg;
      newContext.pageId = transport == null ? void 0 : transport.pgId;
      newContext.pageLanguage = transport == null ? void 0 : transport.pgLang;
      newContext.adTags = transport == null ? void 0 : transport.adTags;
      newContext.pageName = transport == null ? void 0 : transport.pgName;
      newContext.pageLink = transport == null ? void 0 : transport.pgLink;
      newContext.pageImage = transport == null ? void 0 : transport.pgImage;
      newContext.communityName = transport == null ? void 0 : transport.cmName;
      newContext.communityImage = transport == null ? void 0 : transport.cmImage;
      newContext.$time = typeof transport.time === 'number' && transport.time > 0 ? transport.time : Date.now();
    }

    return newContext;
  }
  /** Get PageContext from window (via PageContextTransport)  */
  ;

  PageContext.fromWindow = function fromWindow() {
    var win = window;

    if (win != null && win._plc && typeof win._plc === 'object') {
      return PageContext.fromTransport(win._plc);
    }

    return PageContext.getDefault();
  }
  /** Converts to PageContextTransport */
  ;

  _proto.toTransport = function toTransport(skipTime) {
    if (skipTime === void 0) {
      skipTime = false;
    }

    var plc = {
      p: this.product,
      pId: this == null ? void 0 : this.productId,
      pVar: this == null ? void 0 : this.productVariant,
      pCat: this == null ? void 0 : this.productCategory,
      pg: this == null ? void 0 : this.page,
      pgId: this == null ? void 0 : this.pageId,
      pgLang: this == null ? void 0 : this.pageLanguage,
      adTags: this == null ? void 0 : this.adTags,
      pgName: this == null ? void 0 : this.pageName,
      pgLink: this == null ? void 0 : this.pageLink,
      pgImage: this == null ? void 0 : this.pageImage,
      cmName: this == null ? void 0 : this.communityName,
      cmImage: this == null ? void 0 : this.communityImage,
      time: this.time
    };

    if (skipTime) {
      plc.time = 0;
    }

    return plc;
  }
  /** Converts to stringified PageContextTransport */
  ;

  _proto.toString = function toString(skipTime) {
    if (skipTime === void 0) {
      skipTime = false;
    }

    return JSON.stringify(this.toTransport(skipTime));
  }
  /** Updates window with stringified PageContextTransport */
  ;

  _proto.updateWindow = function updateWindow(dynamicTime) {
    if (dynamicTime === void 0) {
      dynamicTime = false;
    }

    var win = window;
    win._plc = this.toTransport(dynamicTime);

    if (dynamicTime) {
      win._plc.time = Date.now();
    }
  }
  /** Updates script that updates window with stringified PageContextTransport */
  ;

  _proto.toScript = function toScript(dynamicTime) {
    if (dynamicTime === void 0) {
      dynamicTime = false;
    }

    var script = "window._plc = " + this.toString(dynamicTime) + ";";

    if (dynamicTime) {
      script += 'window._plc.time = Date.now();';
    }

    return script;
  };

  _createClass(PageContext, [{
    key: "time",
    get: function get() {
      return this.$time;
    }
  }, {
    key: "isUnknown",
    get: function get() {
      return !this.isKnown;
    }
  }, {
    key: "isKnown",
    get: function get() {
      return typeof this.product === 'string' && this.product !== Product.UNKNOWN;
    }
    /** is ProductContext vaild? is Product not unknown and has defined id ? */

  }, {
    key: "isValid",
    get: function get() {
      return this.isKnown && this.$time > 0;
    }
  }]);

  return PageContext;
}();

function getServicesRoot(serviceName) {
  var _window, _window$location;

  var hostname = (_window = window) == null ? void 0 : (_window$location = _window.location) == null ? void 0 : _window$location.hostname;

  if (hostname) {
    if (hostname.endsWith('fandom.com')) {
      return "https://services.fandom.com/" + serviceName;
    }

    if (hostname.endsWith('fandom-dev.us')) {
      return "https://services.fandom-dev.us/" + serviceName;
    }
  }

  return "http://" + serviceName;
}

function fetchJson(serviceName, path, options) {
  if (path === void 0) {
    path = '/';
  }

  if (options === void 0) {
    options = {};
  }

  return fetch(getServicesRoot(serviceName) + path, options).then(function (response) {
    // file uploads end up here
    if (response.type === 'opaque') {
      return response.json();
    } // if we have 401 UNAUTHORIZED or 404 we don't need to log the error


    if (!response.ok && response.status !== 401 && response.status !== 404) {
      console.error('fetch Error', {
        serviceName: serviceName,
        path: path,
        response: response
      });
    }

    return response.json();
  });
}

function whoami() {
  return _whoami.apply(this, arguments);
}

function _whoami() {
  _whoami = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee() {
    var _body$userId, body, whoamiId;

    return runtime_1.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return fetchJson('whoami', '/', {
              credentials: 'include'
            });

          case 3:
            body = _context.sent;
            whoamiId = (_body$userId = body == null ? void 0 : body.userId) != null ? _body$userId : "" + UserContext.ANON_USER;
            return _context.abrupt("return", parseInt(whoamiId, 10));

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);

          case 10:
            return _context.abrupt("return", UserContext.ANON_USER);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 8]]);
  }));
  return _whoami.apply(this, arguments);
}

function getUserContextWithFallback() {
  return _getUserContextWithFallback.apply(this, arguments);
}

function _getUserContextWithFallback() {
  _getUserContextWithFallback = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee() {
    var user;
    return runtime_1.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            user = UserContext.fromWindow();

            if (!user.isUnknown) {
              _context.next = 12;
              break;
            }

            _context.prev = 2;
            _context.next = 5;
            return whoami();

          case 5:
            user.id = _context.sent;
            _context.next = 12;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](2);
            console.debug('Failed, falling back to default user context', _context.t0);
            return _context.abrupt("return", UserContext.getDefault());

          case 12:
            return _context.abrupt("return", user);

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 8]]);
  }));
  return _getUserContextWithFallback.apply(this, arguments);
}

function getFallbackProduct() {
  var _window$location$path, _window, _window$location, _window$location$host, _window2, _window2$location;

  var pathname = (_window$location$path = (_window = window) == null ? void 0 : (_window$location = _window.location) == null ? void 0 : _window$location.pathname) != null ? _window$location$path : '';
  var host = (_window$location$host = (_window2 = window) == null ? void 0 : (_window2$location = _window2.location) == null ? void 0 : _window2$location.host) != null ? _window$location$host : '';

  if (host.endsWith('.fandom.com')) {
    if (pathname.startsWith('/f')) {
      return Product.DISCUSSIONS;
    }

    if (pathname.startsWith('/wiki')) {
      return Product.MEDIAWIKI;
    }

    if (host === 'www.fandom.com') {
      if (pathname.startsWith('/trivia')) {
        return Product.TRIVIA;
      }

      if (pathname.startsWith('/video')) {
        return Product.VIDEO;
      }

      if (pathname.startsWith('/fancentral')) {
        return Product.FANHUB;
      }

      return Product.F2;
    }

    if (host === 'auth.fandom.com') {
      return Product.AUTH;
    }
  }

  return Product.UNKNOWN;
}

function getPageContextWithFallback() {
  return _getPageContextWithFallback.apply(this, arguments);
}

function _getPageContextWithFallback() {
  _getPageContextWithFallback = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee() {
    var pageContext;
    return runtime_1.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            pageContext = PageContext.fromWindow(); // fill the page context with the fallback values

            if (typeof (pageContext == null ? void 0 : pageContext.product) !== 'string') {
              pageContext.product = getFallbackProduct();
            }

            return _context.abrupt("return", pageContext);

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getPageContextWithFallback.apply(this, arguments);
}

/** Doesn't make any sense per se, but it's needed for adding all those FlatAdTags together */
function flatAdTagsToCounted(adTags) {
  if (typeof adTags !== 'object') {
    return {};
  }

  var countedAdTags = {};

  for (var _i = 0, _Object$entries = Object.entries(adTags); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _Object$entries[_i],
        tagName = _Object$entries$_i[0],
        tagValues = _Object$entries$_i[1];
    var tagNameTyped = tagName;

    if (tagValues) {
      countedAdTags[tagNameTyped] = tagValues.reduce(function (previous, c) {
        previous[c] = 1;
        return previous;
      }, {});
    }
  }

  return countedAdTags;
}
/** Add multiple `CountedAdTags` together */

function sumAdTags(multipleAdTags) {
  var countedAdTags = {};
  multipleAdTags.forEach(function (adTags) {
    for (var _i2 = 0, _Object$entries2 = Object.entries(adTags); _i2 < _Object$entries2.length; _i2++) {
      var _countedAdTags$tagNam;

      var _Object$entries2$_i = _Object$entries2[_i2],
          tagName = _Object$entries2$_i[0],
          tagValues = _Object$entries2$_i[1];
      // fix the type
      var tagNameTyped = tagName;
      var current = (_countedAdTags$tagNam = countedAdTags[tagNameTyped]) != null ? _countedAdTags$tagNam : {};

      if (tagValues) {
        for (var _i3 = 0, _Object$entries3 = Object.entries(tagValues); _i3 < _Object$entries3.length; _i3++) {
          var _current$tagValueName;

          var _Object$entries3$_i = _Object$entries3[_i3],
              tagValueName = _Object$entries3$_i[0],
              tagValueCount = _Object$entries3$_i[1];
          current[tagValueName] = ((_current$tagValueName = current[tagValueName]) != null ? _current$tagValueName : 0) + tagValueCount;
        }
      }

      countedAdTags[tagNameTyped] = current;
    }
  });
  return countedAdTags;
}

/** Make sure list unique and sorted in reverse chronological order */

function cleanPageContextList(list) {
  return uniqBy(list, function (context) {
    return context.time;
  }).sort(function (a, b) {
    return b.time - a.time;
  });
}
/** Check if context is "same" as the other - same product and page, rest of the fields doesn't matter */

function isPageContextEqual(a, b) {
  return a instanceof PageContext && b instanceof PageContext && a.product === b.product && a.productId === b.productId && a.page === b.page && a.pageId === b.pageId;
}
/** Create function for updating context in window, with optional callback */

function updatePageContextFactory(defaultParams, cb) {
  return function (params) {
    var _ref, _params$product, _params$productId, _params$productVarian, _params$productCatego, _params$page, _params$pageId, _params$pageLanguage, _params$adTags;

    // create context instance and update it
    var context = PageContext.getDefault();
    context.product = (_ref = (_params$product = params == null ? void 0 : params.product) != null ? _params$product : defaultParams == null ? void 0 : defaultParams.product) != null ? _ref : Product.UNKNOWN;
    context.productId = (_params$productId = params == null ? void 0 : params.productId) != null ? _params$productId : defaultParams == null ? void 0 : defaultParams.productId;
    context.productVariant = (_params$productVarian = params == null ? void 0 : params.productVariant) != null ? _params$productVarian : defaultParams == null ? void 0 : defaultParams.productVariant;
    context.productCategory = (_params$productCatego = params == null ? void 0 : params.productCategory) != null ? _params$productCatego : defaultParams == null ? void 0 : defaultParams.productCategory;
    context.page = (_params$page = params == null ? void 0 : params.page) != null ? _params$page : defaultParams == null ? void 0 : defaultParams.page;
    context.pageId = (_params$pageId = params == null ? void 0 : params.pageId) != null ? _params$pageId : defaultParams == null ? void 0 : defaultParams.pageId;
    context.pageLanguage = (_params$pageLanguage = params == null ? void 0 : params.pageLanguage) != null ? _params$pageLanguage : defaultParams == null ? void 0 : defaultParams.pageLanguage;
    context.adTags = (_params$adTags = params == null ? void 0 : params.adTags) != null ? _params$adTags : defaultParams == null ? void 0 : defaultParams.adTags; // update window

    context.updateWindow();

    if (typeof cb === 'function') {
      setTimeout(cb, 1);
    }
  };
}

// https://github.com/Wikia/unified-platform/blob/2e85347cf97b506e10cbf263d0d843c4f0ff7256/extensions/fandom/Track/templates/tracking-cookies.mustache

/** Non-RFC compliant UUID */
function genUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0,
        v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
}

// https://stackoverflow.com/a/25346429/1416255
function escape(s) {
  // eslint-disable-next-line no-useless-escape
  return s.replace(/([.*+?\^$(){}|\[\]\/\\])/g, '\\$1');
}

function getCookieByName(name) {
  var match = document.cookie.match(RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)'));
  return match ? match[1] : undefined;
}
function getObjectFromCookieByName(name) {
  try {
    var _getCookieByName;

    var cookie = decodeURIComponent((_getCookieByName = getCookieByName(name)) != null ? _getCookieByName : '{}');
    return cookie ? JSON.parse(cookie) : undefined;
  } catch (e) {
    return undefined;
  }
}

function getWikiaBeaconId() {
  return getCookieByName('wikia_beacon_id') || '';
}
function getBeacon2Id() {
  return getCookieByName('_b2') || '';
}
function getExpBucket() {
  return getCookieByName('exp_bucket') || '';
}
var CONSISTENT_RANDOM_NUMBER_KEY = '__fandom_consistent_random';
function getConsistentRandomNumber() {
  // cast on widow to get nice typings
  var win = window; // if we have number on window, use it

  if (win[CONSISTENT_RANDOM_NUMBER_KEY]) {
    return win[CONSISTENT_RANDOM_NUMBER_KEY];
  }

  var randomNumber = Math.random();
  win[CONSISTENT_RANDOM_NUMBER_KEY] = randomNumber;
  return randomNumber;
}
function getPvUID() {
  // cast on widow to get nice typings
  var win = window; // if we have pvUID on window, use it

  if (win != null && win.pvUID) {
    return win.pvUID;
  } // set new pvUID on window


  var pvUID = genUID();
  win.pvUID = pvUID;
  return pvUID;
}
function getGeo() {
  var _getObjectFromCookieB;

  return (_getObjectFromCookieB = getObjectFromCookieByName('Geo')) != null ? _getObjectFromCookieB : {};
}

function updateUserContextOnWindow(userId) {
  if (typeof window !== 'undefined') {
    var context = UserContext.getAnon();
    context.id = userId;
    context.updateWindow();
    return true;
  }

  return false;
}
function updatePageContextOnWindow(page, pageId, defaultPageContextTransport) {
  if (defaultPageContextTransport === void 0) {
    defaultPageContextTransport = {};
  }

  if (typeof window !== 'undefined') {
    var context = PageContext.fromTransport(defaultPageContextTransport);
    context.page = page;
    context.pageId = pageId;
    context.updateWindow(true);
    return true;
  }

  return false;
}

function getPageContextFromWindow() {
  return PageContext.fromWindow();
}
function getUserContextFromWindow() {
  return UserContext.fromWindow();
}
function getContextFromWindow() {
  return {
    current: getPageContextFromWindow(),
    user: getUserContextFromWindow()
  };
}
function getContextWithFallback() {
  return _getContextWithFallback.apply(this, arguments);
}

function _getContextWithFallback() {
  _getContextWithFallback = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee() {
    return runtime_1.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getPageContextWithFallback();

          case 2:
            _context.t0 = _context.sent;
            _context.next = 5;
            return getUserContextWithFallback();

          case 5:
            _context.t1 = _context.sent;
            return _context.abrupt("return", {
              current: _context.t0,
              user: _context.t1
            });

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getContextWithFallback.apply(this, arguments);
}

export { CONSISTENT_RANDOM_NUMBER_KEY, PageContext, Product, UserContext, cleanPageContextList, flatAdTagsToCounted, getBeacon2Id, getConsistentRandomNumber, getContextFromWindow, getContextWithFallback, getExpBucket, getGeo, getPageContextFromWindow, getPageContextWithFallback, getPvUID, getUserContextFromWindow, getUserContextWithFallback, getWikiaBeaconId, isPageContextEqual, sumAdTags, updatePageContextFactory, updatePageContextOnWindow, updateUserContextOnWindow };
//# sourceMappingURL=context.esm.js.map
